import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import './App.css';

// Lazy load pages that aren't immediately visible
const TradingPlatform = lazy(() => import('./pages/TradingPlatform'));
const Insurance = lazy(() => import('./pages/Insurance'));
const Tourism = lazy(() => import('./pages/Tourism'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const ClientTools = lazy(() => import('./pages/ClientTools'));
const MutualFunds = lazy(() => import('./pages/MutualFunds'));
const Forms = lazy(() => import('./pages/Forms'));
const Contact = lazy(() => import('./pages/Contact'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));

// Loading component for lazy-loaded pages
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-teal-600 border-r-transparent"></div>
      <p className="mt-4 text-neutral-600">Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-white">
          <Header />
          <div className="pt-[120px]">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/trading" element={<TradingPlatform />} />
                <Route path="/insurance" element={<Insurance />} />
                <Route path="/tourism" element={<Tourism />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/client-tools" element={<ClientTools />} />
                <Route path="/mutual-funds" element={<MutualFunds />} />
                <Route path="/forms" element={<Forms />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-conditions" element={<TermsConditions />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
              </Routes>
            </Suspense>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
